import React from 'react';
import styled from 'styled-components';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    usingRef: Function;
    showError: boolean;
    labelClassName: string;
    isTransparent?: boolean;
}

const Input = styled.input`
    opacity: 0;
    position: absolute;
    z-index: -1;
`;

const LabelText = styled.span<{ isTransparent?: boolean }>`
    display: inline-block;
    margin-left: 2.25em;
    font-size: 0.75rem;
    line-height: 1.45;
    letter-spacing: 0.03325em;
    cursor: pointer;

    &::before {
        content: '';
        display: block;
        width: 1.5em;
        height: 1.5em;
        border: 1px solid ${props => props.theme.colors.charcoal20};
        text-align: center;
        line-height: 1.5;
        position: absolute;
        top: 0;
        left: 0;
        background: ${props => (props.isTransparent ? 'transparent' : 'white')};
    }

    ${Input}:checked + &::before {
        content: '\u2713';
        color: ${props => props.theme.colors.turquoise100};
    }

    & a {
        text-decoration: underline;
    }
`;

const Label = styled.label<{ showError: boolean }>`
    display: block;
    text-align: left;
    position: relative;

    ${props =>
        props.showError &&
        `
            color: ${props.theme.colors.red60};
            
            & ${LabelText}::before {
                border-color: ${props.theme.colors.red60};
            }
            
            & a {
                color: ${props.theme.colors.red60} !important;
            }
    `}
`;

const Checkbox: React.FunctionComponent<CheckboxProps> = ({
    usingRef,
    showError,
    labelClassName,
    isTransparent,
    children,
    ...props
}) => (
    <Label showError={showError} className={labelClassName}>
        <Input ref={usingRef()} type="checkbox" {...props} />
        <LabelText isTransparent={isTransparent}>{children}</LabelText>
    </Label>
);

export default Checkbox;
